import {
    ChangeDetectorRef,
    Directive,
    ElementRef,
    inject,
    Input,
    OnDestroy,
    OnInit,
    Renderer2,
} from '@angular/core';

import { QWYK_TABLE } from './table.component';

@Directive({
    standalone: true,
    selector: '[qwykReorderableColumn]',
    host: {
        '[class.qwyk-reorder-drag-over]': '_dragOver',
    },
})
export class QwykReorderableColumnDirective implements OnInit, OnDestroy {
    /** Column index in the current displayed order */
    @Input('qwykReorderableColumn') columnIndex: number;

    _dragOver = false;

    private readonly _el = inject(ElementRef<HTMLElement>);
    private readonly _renderer = inject(Renderer2);
    private readonly _cdr = inject(ChangeDetectorRef);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private readonly _table = inject<any>(QWYK_TABLE, { optional: true });
    private _cleanup: (() => void)[] = [];

    ngOnInit(): void {
        const el = this._el.nativeElement;
        this._renderer.setAttribute(el, 'draggable', 'true');

        this._cleanup.push(
            this._renderer.listen(el, 'dragstart', (e: DragEvent) => {
                // Block drag while any filter overlay is open
                if (this._table?._filterOverlayOpen) {
                    e.preventDefault();
                    return;
                }
                e.stopPropagation();
                if (e.dataTransfer) {
                    e.dataTransfer.effectAllowed = 'move';
                    e.dataTransfer.setData('text/plain', String(this.columnIndex));
                }
                if (this._table) {
                    this._table._dragColumnIndex = this.columnIndex;
                }
            }),
            this._renderer.listen(el, 'dragover', (e: DragEvent) => {
                e.preventDefault();
                if (e.dataTransfer) e.dataTransfer.dropEffect = 'move';
                if (!this._dragOver) {
                    this._dragOver = true;
                    this._cdr.markForCheck();
                }
            }),
            this._renderer.listen(el, 'dragleave', () => {
                this._dragOver = false;
                this._cdr.markForCheck();
            }),
            this._renderer.listen(el, 'drop', (e: DragEvent) => {
                e.preventDefault();
                e.stopPropagation();
                this._dragOver = false;
                if (this._table != null) {
                    this._table._onColumnDrop(this.columnIndex);
                }
                this._cdr.markForCheck();
            }),
            this._renderer.listen(el, 'dragend', () => {
                this._dragOver = false;
                if (this._table) {
                    this._table._dragColumnIndex = null;
                }
                this._cdr.markForCheck();
            })
        );
    }

    ngOnDestroy(): void {
        this._cleanup.forEach(fn => fn());
        this._cleanup = [];
    }
}
